import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { IntegrationTypeEnum } from "@oysterhr/schema"

export const OFFBOARDING_INTEGRATION_QUERY = gql`
  query OffboardingIntegrationQuery($companyId: ID!, $integrationType: String!) {
    mergeIntegration(companyId: $companyId, integrationType: $integrationType) {
      id
      platformName
      addOns {
        key
        active
      }
    }
  }
`

export const useOffboardingIntegration = (companyId: string) =>
  useQuery(OFFBOARDING_INTEGRATION_QUERY, {
    variables: { companyId, integrationType: IntegrationTypeEnum.Hris },
  })
